import { render } from "./PatientMedicalRecordListTab.vue?vue&type=template&id=44de387e&scoped=true"
import script from "./PatientMedicalRecordListTab.vue?vue&type=script&lang=js"
export * from "./PatientMedicalRecordListTab.vue?vue&type=script&lang=js"

import "./PatientMedicalRecordListTab.vue?vue&type=style&index=0&id=44de387e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44de387e"]])

export default __exports__